<script setup>
import ClientPortalListComponent from "@/Components/ClientPortal/ClientPortalListComponent.vue";
// import ClientPortalChartComponent from "@/Components/ClientPortal/ClientPortalChartComponent.vue";
import {Permissions} from "@/Utils/Permissions";

</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" >
        <!--        v-if="Permissions.checkPermissions(['client-portal.list'])"-->
        <ClientPortalListComponent v-if="Permissions.checkPermissions(['client-portal.list'])"/>
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <v-col cols="12">-->
<!--        &lt;!&ndash;        v-if="Permissions.checkPermissions(['client-portal.list'])"&ndash;&gt;-->
<!--        <ClientPortalChartComponent :clientId="route.params.clientId" :clientName="data.clientName"/>-->
<!--      </v-col>-->
<!--    </v-row>-->
  </v-container>
</template>

<style scoped>

</style>